import { z } from "zod";

import { createCall, getSpellbookConfig, spellbook } from "@sdk/spellbook";

type UpdateUserParams = { locale: string };

// Preserve the established lowercase wire field accepted by the legacy Go decoder.
const updateUserCall = createCall(
    {
        ...spellbook("/v1/users/me").PUT(),
        req: z.object({ locale: z.string() }),
    },
    // Team API documents a JSON string here but currently returns raw `OK`.
    // Normalize that response so Spellbook can decode it.
    async (request) => {
        const fetcher = getSpellbookConfig().fetch ?? globalThis.fetch;
        const response = await fetcher(request);

        if (!response.ok || (await response.clone().text()) !== "OK") return response;

        return new Response(JSON.stringify("OK"), {
            status: response.status,
            statusText: response.statusText,
            headers: { "Content-Type": "application/json" },
        });
    },
);

export function updateUser(params: UpdateUserParams) {
    return updateUserCall({ req: { locale: params.locale } });
}
